import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { ReactTyped } from "react-typed";

export default function BigText({ first, array, last }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 8,
        px: 2,
        pb: "20px",
        backgroundColor: "transparent",
        textAlign: "left",
        maxWidth: "100%",
      }}
    >
      <Typography
        variant="h3"
        fontWeight="bold"
        sx={{ lineHeight: 1.2, color: theme.palette.text.primary }}
      >
        {first}
      </Typography>

      <Typography
        variant="h3"
        fontWeight="bold"
        sx={{ lineHeight: 1.2, color: theme.palette.text.primary }}
      >
        <Box
          component="span"
          sx={{ color: theme.palette.primary.main, fontWeight: "bold" }}
        >
          <ReactTyped strings={array} typeSpeed={120} backSpeed={30} loop />
        </Box>{" "}
        {last}
      </Typography>
    </Box>
  );
}
